import { Component, Input, OnInit } from '@angular/core';
import { AppConfigurationDto, LandTitleDto, PurposeDto } from '@cradua/data';

@Component({
  selector: 'cradua-geo-spatial',
  templateUrl: './geo-spatial.component.html',
  styleUrls: ['./geo-spatial.component.scss']
})
export class GeoSpatialComponent implements OnInit {

  @Input() selectedLandTitle: LandTitleDto;
  @Input() purposes: PurposeDto[];
  @Input() appConfigs: AppConfigurationDto[];

  toggleMap = 'custom';
  filteredAppConfigs: AppConfigurationDto[];
  appConfig: AppConfigurationDto;

  constructor() { }

  ngOnInit(): void {
     this.filteredAppConfigs = this.appConfigs.filter(map => map.type === 'DynamicMap');
     this.appConfig = this.appConfigs.find(map => map.type === 'MyMap');
  }

  protected filterById = <T>(id: string, lookupId: string) =>
  (fieldName: T) => fieldName[lookupId] === id;

  getPurposeName(id: string) {
    const found = this.purposes.find(
      this.filterById<PurposeDto>(id, "id"),
    );

    return found ? found.PurposeName : null;
    }

    onToggleMap(value: string) {
      this.toggleMap = value;
    }
}
